// start:ng42.barrel
import './email-templates-client.component';
import './email-templates-container.component';
import './template-type-list.component';
import './template-placeholder-list.component';
// end:ng42.barrel

